import { IconButton } from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { useIsMobile } from "../../../../utils";
import { useMediaQuery } from "react-responsive";

import "./index.css";

interface CloseIconButtonProps {
  step: any | null;
  isShoesProduct: boolean;
  isSportyAndRich: boolean;
  brandName?: string;
  titleStyles: any;
  closeIframe: () => void;
}

export const CloseIconButton = ({
  step,
  isShoesProduct,
  isSportyAndRich,
  brandName,
  titleStyles,
  closeIframe,
}: CloseIconButtonProps) => {
  const isMobile = useIsMobile();

  const isLargeHeightRelative = useMediaQuery({
    maxHeight: 830,
    minWidth: 767,
  });

  const isMediumHeightRelative = useMediaQuery({
    maxHeight: 678,
    minWidth: 767,
  });

  if (!step || step?.number < 0) return null;

  const top =
    isMobile && brandName === "SRP"
      ? "0px"
      : isLargeHeightRelative && brandName !== "Sporty & Rich"
      ? "5px"
      : isMediumHeightRelative && brandName === "Sporty & Rich"
      ? "5px"
      : isShoesProduct && !isSportyAndRich
      ? "5px"
      : "15px";

  return (
    <IconButton
      onClick={closeIframe}
      className="close-icon"
      sx={{
        position: "fixed",
        right: "20px",
        top,
      }}
    >
      <CloseOutlinedIcon
        className="icon"
        style={{
          color: titleStyles.color ?? "black",
          width: isMobile ? "16px" : "18px",
          height: isMobile ? "16px" : "18px",
        }}
      />
    </IconButton>
  );
};

export default CloseIconButton;
